import getBenefitRequestDetail from "v2/infrastructure/BenefitRequests/repositories/getBenefitRequestDetail";

const findBenefitRequestDetail = ({
  companyId,
  requestId,
}: {
  companyId: string;
  requestId: string;
}) => {
  return getBenefitRequestDetail({ companyId, requestId });
};

export default findBenefitRequestDetail;
